import React from "react";
import PropTypes from 'prop-types';

import { FieldValue, serverTimestamp } from "firebase/firestore";
import { db } from "../../lib/firebaseCompat";

import { useTooltip } from "../../hooks/useTooltip";
import { useOrganization } from "../../hooks/useOrganization";

export default function EstimateTdArchive({orgId, docId}) {
  const ref = useTooltip();

  const handleArchive = async (evt) => {
    if (!orgId) {
      return;
    }
    const doc = db
      .collection("organizations")
      .doc(orgId)
      .collection("estimates")
      .doc(docId);

    try {
      await doc.update({
        archived: true,
        updatedAt: serverTimestamp(),
      });
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <td>
      <i
        className="material-icons cursor-pointer red-text text-darken-3"
        data-tooltip="Archive Estimate"
        data-position="left"
        ref={ref}
        onClick={handleArchive}
      >
        archive
      </i>
    </td>
  );
}

EstimateTdArchive.propTypes = {
  orgId: PropTypes.string.isRequired,
  docId: PropTypes.string.isRequired,
}
